import type { MailboxInfo } from "owa-client-types";
import getStore from "../store/store";
import type { ApplicationSettingsOverrides } from "../store/schema/ApplicationSettingsOverrides";

export default function getApplicationSettingOverride(setting: string, mailboxInfo?: MailboxInfo): ApplicationSettingsOverrides {
    const store = getStore(mailboxInfo);
    return store.overrides[setting];
}
